import React, { useCallback } from 'react';
import { getArrayLength, normalizeEmail } from 'utils';
import classNames from 'classnames';
import { DataRoomSecuritySettings } from 'router/subrouters/DataRoom/models/DataRoom';
import { DATE_FORMAT_COMPACT, getFormattedDate } from 'dateUtils';
import { ObjectValues } from 'types';

import './FileWatermark.styles.scss';

const WATERMARK_DIRECTION = {
  DIAGONAL: 'diagonal',
  HEADER: 'header',
  FOOTER: 'footer',
} as const;

type WatermarkDirection = ObjectValues<typeof WATERMARK_DIRECTION>;

export type FileWatermarkProps = {
  className?: string;
  fullName: string;
  email: string;
  watermarkSettings: DataRoomSecuritySettings;
  ipAddress?: string;
};

const FileWatermark: React.FC<FileWatermarkProps> = (props) => {
  const { className, fullName, email, ipAddress, watermarkSettings } = props;

  const {
    watermarkDiagonal,
    watermarkHeader,
    watermarkFooter,
    watermarkFullName,
    watermarkEmail,
    watermarkIpAddress,
  } = watermarkSettings;

  const activeDirections = [
    watermarkHeader && WATERMARK_DIRECTION.HEADER,
    watermarkDiagonal && WATERMARK_DIRECTION.DIAGONAL,
    watermarkFooter && WATERMARK_DIRECTION.FOOTER,
  ].filter(Boolean) as WatermarkDirection[];

  const activeLength = getArrayLength(activeDirections);

  const classes = classNames(
    'file-watermark',
    className,
    `count-${activeLength}`,
  );

  const renderWatermark = useCallback(
    (direction: WatermarkDirection) => (
      <div className={classNames('file-watermark__text', direction)}>
        {watermarkEmail && <div>{normalizeEmail(email)}</div>}
        {watermarkFullName && <div>{fullName}</div>}
        {watermarkIpAddress && (
          <>
            <div>{ipAddress}</div>
            <div>{getFormattedDate(new Date(), DATE_FORMAT_COMPACT)}</div>
          </>
        )}
      </div>
    ),
    [
      email,
      fullName,
      watermarkEmail,
      watermarkFullName,
      watermarkIpAddress,
      ipAddress,
    ],
  );

  if (
    (!watermarkEmail && !watermarkFullName && !watermarkIpAddress) ||
    !activeLength
  )
    return null;

  return <div className={classes}>{activeDirections.map(renderWatermark)}</div>;
};

export default FileWatermark;
